import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { Link } from 'react-router-dom';

export default function ProductsMegaMenuTabLink({
  tab,
  toggle,
  name,
  link,
  tabId,
  setMegaMenuTab,
  starDeal,
  from,
}) {
  const onClick = () => {
    setMegaMenuTab('');
  };

  return (
    <li className={classNames('ProductsMegaMenu__link', { 'ProductsMegaMenu__link--stardeal': starDeal })}>
      <Link
        to={link}
        tabIndex={0}
        role="menuitem"
        id={`${from}-${tabId}`}
        className={classNames('ProductsMegaMenu__link__tag', { 'ProductsMegaMenu__link__tag--active': tab === `${tabId}` }, { 'ProductsMegaMenu__link__tag--stardeal': starDeal })}
        onMouseEnter={() => toggle(`${tabId}`)}
        onClick={onClick}
      >
        {name}
      </Link>
    </li>
  );
}

ProductsMegaMenuTabLink.propTypes = {
  tab: PropTypes.string,
  toggle: PropTypes.func,
  name: PropTypes.string,
  link: PropTypes.string,
  tabId: PropTypes.string,
  setMegaMenuTab: PropTypes.func,
  starDeal: PropTypes.bool,
  from: PropTypes.string.isRequired,
};

ProductsMegaMenuTabLink.defaultProps = {
  tab: '1',
  toggle: () => {},
  name: '',
  tabId: '1',
  link: null,
  setMegaMenuTab: () => {},
  starDeal: false,
};
